import { makeActionCreator } from 'app/utils/redux';
import * as storageActionCreatorCreators from 'app/models/storage/actions';
import { getDangerousNativeSessionStorage } from 'app/utils/env';
import {
  INIT,
  SET_ITEM,
  REMOVE_ITEM,
  Storage,
  validateKey,
} from 'app/models/sessionStorage/constants';
import {
  getItem,
  wasSessionStorageInitiallyAvailable,
} from 'app/models/sessionStorage/selectors';

export const initAction =
  makeActionCreator(INIT, 'wasStorageInitiallyAvailable', 'storageCopy');
export const setItemAction = makeActionCreator(SET_ITEM, 'key', 'value');
export const removeItemAction = makeActionCreator(REMOVE_ITEM, 'key');

/**
 * The init action creator, wraps the common storage init action creator.
 * Check the common storage actions file for more details.
 *
 */
export const init = () => (dispatch, getState) => {
  dispatch(storageActionCreatorCreators.init(
    Storage,
    getDangerousNativeSessionStorage,
    initAction,
    getItem,
  )());
};

/**
 * @deprecated Use StorageContext instead
 */
export const setItem = storageActionCreatorCreators.setItem(
  validateKey,
  wasSessionStorageInitiallyAvailable,
  getDangerousNativeSessionStorage,
  setItemAction,
);

/**
 * @deprecated Use StorageContext instead
 */
export const removeItem = storageActionCreatorCreators.removeItem(
  validateKey,
  wasSessionStorageInitiallyAvailable,
  getDangerousNativeSessionStorage,
  removeItemAction,
);
